import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { ImageBoxTwo, SecSubTitle, Button, SecTitle } from "../../components";

// FAQ Data
import faqData from "../../data/trainingFaq.json";

const FaqTwo = ({ className }) => (
  <div className={`faq-wrap1 ${className || ""}`}>
    <div
      className="faq-shape1 background-image"
      style={{ backgroundImage: "url(images/bg/faq-bg-1-1.jpg)" }}
    ></div>
    <div
      className="faq-shape2 background-image"
      style={{ backgroundImage: "url(images/bg/faq-bg-1-2.jpg)" }}
    ></div>
    <div className="container">
      <div className="row gx-60">
        <div className="col-lg-6 pb-20 pb-lg-0">
          <ImageBoxTwo
            imageOne="images/faq/faq-1-1.jpg"
            imageTwo="images/faq/faq-1-2.jpg"
            // video="https://www.dropbox.com/s/b4k0p5swok5l8t2/videoplayback.mp4?dl=1"
          />
          {/* <SecTitle
            className="h2 text-white"
            style={{
              backgroundColor: "var(--theme-color)!important",
            }}
          >
            Ready to Build Your SAP Career?
          </SecTitle> */}
          <h3
            className="sec-title h3 text-white text-center"
            style={{
              backgroundColor: "var(--theme-color)",
              padding: "15px 25px",
              borderRadius: "10px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
              display: "inline-block",
              fontWeight: "600",
              letterSpacing: "0.5px",
            }}
          >
            Ready to Build Your SAP Career?
          </h3>
          <Button path="/contact">
            Join Now <i className="far fa-arrow-right" />
          </Button>
        </div>
        <div className="col-lg-6 align-self-center">
          <SecSubTitle className="text-white">
            <i className="fas fa-bring-forward" />
            Talk About Something
          </SecSubTitle>
          <SecTitle className="text-white mb-4 pb-2 h1">
            How can we help you?
          </SecTitle>
          <Accordion
            defaultActiveKey={faqData[0].questionId}
            className="accordion-style1"
          >
            {faqData.map((item) => (
              <Accordion.Item key={item.questionId} eventKey={item.questionId}>
                <Accordion.Header>{item.question}</Accordion.Header>
                <Accordion.Body>
                  <p>{item.answer}</p>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  </div>
);

export default FaqTwo;
